export const COMPARE_OPTIONS = [
	{
		label: 'Landing',
		value: 'AD_QUIZ_LP',
	},
	{
		label: 'Question 1',
		value: 'AD_QUIZ_Q1',
	},
	{
		label: 'Question 2',
		value: 'AD_QUIZ_Q2',
	},
	{
		label: 'Question 3',
		value: 'AD_QUIZ_Q3',
	},
	{
		label: 'Question 4',
		value: 'AD_QUIZ_Q4',
	},
	{
		label: 'Question 5',
		value: 'AD_QUIZ_Q5',
	},
	{
		label: 'Question 6',
		value: 'AD_QUIZ_Q6',
	},
	{
		label: 'Question 7',
		value: 'AD_QUIZ_Q7',
	},
	{
		label: 'Question 8',
		value: 'AD_QUIZ_Q8',
	},
	{
		label: 'Question 9',
		value: 'AD_QUIZ_Q9',
	},
	{
		label: 'Question 10',
		value: 'AD_QUIZ_Q10',
	},
	{
		label: 'Question 11',
		value: 'AD_QUIZ_Q11',
	},
	{
		label: 'Question 12',
		value: 'AD_QUIZ_Q12',
	},
	{
		label: 'Question 13',
		value: 'AD_QUIZ_Q13',
	},
	{
		label: 'Question 14',
		value: 'AD_QUIZ_Q14',
	},
	{
		label: 'Question 15',
		value: 'AD_QUIZ_Q15',
	},
	{
		label: 'Question 16',
		value: 'AD_QUIZ_Q16',
	},
	{
		label: 'Lead Page',
		value: 'AD_QUIZ_LEAD',
	},
	{
		label: 'Lead Submitted',
		value: 'AD_QUIZ_LEAD_SUBMITTED',
	},
	{
		label: 'SP View',
		value: 'AD_QUIZ_SP',
	},
	{
		label: 'SP Promo View',
		value: 'AD_QUIZ_SP_PROMO',
	},
	{
		label: 'Checkout View',
		value: 'AD_QUIZ_CHECKOUT',
	},
	{
		label: 'Checkout View Promo',
		value: 'AD_QUIZ_CHECKOUT_PROMO',
	},
	{
		label: 'Init Checkout',
		value: 'AD_QUIZ_INIT_CHECKOUT',
	},
	{
		label: 'Init Checkout Promo',
		value: 'AD_QUIZ_INIT_CHECKOUT_PROMO',
	},
	{
		label: 'Purchase',
		value: 'PURCHASE',
	},
];
